import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';
import { Card, CardContent } from '../../../components/ui/card';

const ReputationFactors = ({ factors }) => {
  return (
    <Card>
      <CardContent className="pt-6">
        <h3 className="text-lg font-semibold text-[#2B2D42] mb-4">Contributing Factors</h3>
        
        {factors && factors.length > 0 ? (
          <div className="space-y-3">
            {factors.map((factor, index) => {
              const isPositive = factor.value > 0;
              const color = isPositive ? '#10B981' : '#EF4444';
              const bgColor = isPositive ? 'bg-green-50' : 'bg-red-50';
              
              return (
                <div
                  key={index}
                  className={`flex items-center justify-between p-3 rounded-lg ${bgColor}`}
                >
                  <div className="flex items-center space-x-2 flex-1">
                    {isPositive ? (
                      <TrendingUp className="h-5 w-5" style={{ color }} />
                    ) : (
                      <TrendingDown className="h-5 w-5" style={{ color }} />
                    )}
                    <span className="text-sm font-medium text-[#2B2D42]">
                      {factor.label}
                    </span>
                  </div>
                  <span
                    className="text-lg font-bold px-3"
                    style={{ color }}
                  >
                    {factor.value > 0 ? '+' : ''}{factor.value}
                  </span>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="text-center py-8 text-[#6C757D] text-sm">
            No factors available
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default ReputationFactors;
